import React from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import ItemDelete from '../../../components/Delete'

const IncidentDivisionBufferDelete = () => (
  <ItemDelete
    routeName={ROUTE_NAME}
    apiUrl={API_URL}
    label={(item) =>
      `Division Buffer (#${item.id}): ${item.division.name} - ${item.aiLayer.name} - ${item.distance} ${item.unit}`
    }
  />
)

export default IncidentDivisionBufferDelete
